/** Every API route lives under this prefix (api-design §1). A breaking change creates `/api/v2`. */
export const API_BASE_PATH = '/api/v1';
